/**
 * utility function to safely parse json without throwing runtime exceptions.
 * @param data - any stringified json object
 * @returns - json object if the string is parsable otherwise returns undefined.
 */
export var safeJsonParse = function (data) {
    try {
        if (data) {
            return JSON.parse(data);
        }
    }
    catch (err) {
        return undefined;
    }
};
